/**
 * The horizontal alignment of the text.
 */
export enum TextHorizontalAlignment {
  /** Align left horizontally */
  Left = 0,
  /** Align center horizontally */
  Center = 1,
  /** Align right horizontally */
  Right = 2
}

/**
 * The vertical alignment of the text.
 */
export enum TextVerticalAlignment {
  /** Align top vertically */
  Top = 0,
  /** Align center vertically */
  Center = 1,
  /** Align bottom vertically */
  Bottom = 2
}
